import clsx from 'clsx'

import type { FooterProps } from './type'

export const Footer = ({ inputRef, children }: FooterProps) => {
  return (
    <div
      ref={inputRef}
      className={clsx([
        'tw-inset-x-0 tw-bottom-0',
        'tw-w-full',
        'tw--drop-shadow-300',
      ])}
    >
      {children}
    </div>
  )
}
